var _defs, _rect, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_187",
    "data-name": "Grupo 187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 418,
    height: 92.884,
    viewBox: "0 0 418 92.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_92",
    "data-name": "Ret\\xE2ngulo 92",
    width: 418,
    height: 92.884,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_90",
    "data-name": "Ret\\xE2ngulo 90",
    width: 80.19,
    height: 91.615,
    transform: "translate(337.81 0.568)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M0,2.956V45.692H32.154V35.485H12.868V28.5H28.459V19.017H12.868v-6.2H32.154V2.956Z",
    transform: "translate(0 -2.299)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    "data-name": "Caminho 428",
    d: "M188.515,2.956,176.093,22.779l14.394,22.912H175.223l-7.891-13.458-7.966,13.458h-12l13.766-22.067-13.2-20.669h15.3l6.63,11.5,6.882-11.5Z",
    transform: "translate(-114.589 -2.299)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    "data-name": "Caminho 429",
    d: "M358.6,13.193v32.5H346.166v-32.5h-8.86V2.956h30.149V13.193Z",
    transform: "translate(-262.291 -2.298)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    "data-name": "Caminho 430",
    d: "M521.781,35.485V45.691H489.627V2.956h32.154v9.862H502.495v6.2h15.592V28.5H502.495v6.982Z",
    transform: "translate(-380.738 -2.298)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_185",
    "data-name": "Grupo 185",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    "data-name": "Caminho 431",
    d: "M694.112,45.692H683.437l-11.7-18.882a71.91,71.91,0,0,1-4.545-8.826A29.743,29.743,0,0,1,668.221,25V45.692H657.576V2.956h12.4l9.957,15.653a60.412,60.412,0,0,1,4.507,8.2,62.13,62.13,0,0,1-1-11.208V2.956h10.676Z",
    transform: "translate(-511.336 -2.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    "data-name": "Caminho 432",
    d: "M835.521,31.025,847.7,28.834Q849.233,34,855.589,34q4.946,0,4.947-2.63a2.44,2.44,0,0,0-1.144-2.144,12.266,12.266,0,0,0-4.086-1.361q-11.242-2.154-14.434-5.63a11.69,11.69,0,0,1-3.192-8.174,12.793,12.793,0,0,1,4.587-10.052Q846.854,0,855.464,0q13.055,0,17.251,10.488l-10.864,3.287q-1.69-4.289-6.857-4.289-4.289,0-4.289,2.661a2.1,2.1,0,0,0,.97,1.847,11.864,11.864,0,0,0,3.758,1.251,79.419,79.419,0,0,1,10.9,2.87,11.742,11.742,0,0,1,5.384,4.271,11.938,11.938,0,0,1,2.159,7.127,12.626,12.626,0,0,1-5.26,10.511q-5.26,4.025-13.807,4.025-15.623,0-19.286-13.024",
    transform: "translate(-649.707 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_91",
    "data-name": "Ret\\xE2ngulo 91",
    width: 13.118,
    height: 42.736,
    transform: "translate(229.176 0.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    "data-name": "Caminho 433",
    d: "M1147.685,2.956l-13.262,42.736h-13.369L1107.188,2.956h13.824l6.763,23.293q.692,2.066,1.228,4.07l7.9-27.363Z",
    transform: "translate(-860.957 -2.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M1313.574,44.05q-9.016,0-14.7-5.98t-5.683-16q0-9.58,5.432-15.826T1313.7,0q8.923,0,14.543,5.886t5.62,15.717q0,10.175-5.667,16.312a19,19,0,0,1-14.621,6.136m-.063-9.705a4.961,4.961,0,0,0,4.775-2.9q1.454-2.9,1.455-10.6,0-11.145-5.98-11.146-6.45,0-6.449,12.711,0,11.928,6.2,11.928",
    transform: "translate(-1005.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M33.719,237.8v39.394H21.627V261.867H12.391v15.325H.3V237.8H12.391v14.488h9.235V237.8Z",
    transform: "translate(-0.233 -184.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    "data-name": "Caminho 436",
    d: "M191.723,277.192l-2.227-7.763H178.943l-2.365,7.763h-9.817L178.922,237.8h12.785l12.355,39.394ZM181,260.828h6.373L184.185,249.4Z",
    transform: "translate(-129.675 -184.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    "data-name": "Caminho 437",
    d: "M385.872,277.192H372.466l-5.754-15.065H362.9v15.065H350.807V237.8h20.577q6.81,0,10.577,3.189a10.483,10.483,0,0,1,3.766,8.413,12.649,12.649,0,0,1-1.385,6.017q-1.385,2.612-5.6,4.6ZM362.9,253.7h5.166a6.357,6.357,0,0,0,3.665-.952,3.179,3.179,0,0,0,1.385-2.8q0-3.78-4.646-3.781H362.9Z",
    transform: "translate(-272.79 -184.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_438",
    "data-name": "Caminho 438",
    d: "M534.172,277.192V237.8H549.41q9.927,0,14.863,5.887a20.578,20.578,0,0,1,4.935,13.622q0,8.831-5.3,14.358t-13.751,5.527Zm12.092-9.062h3.146a6.062,6.062,0,0,0,5.065-2.915,13.512,13.512,0,0,0,2.064-7.936,14.382,14.382,0,0,0-1.832-7.417,5.813,5.813,0,0,0-5.3-3.117h-3.146Z",
    transform: "translate(-415.376 -184.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_439",
    "data-name": "Caminho 439",
    d: "M753.435,237.8l-10.448,39.394H732.828l-5.511-21.732-5.2,21.732H711.522L701.055,237.8h11.379l5.51,22.673L723.32,237.8h9.494l5.848,22.718L744.18,237.8Z",
    transform: "translate(-545.145 -184.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_440",
    "data-name": "Caminho 440",
    d: "M960.436,275.679a17.851,17.851,0,0,1-13.55-5.512q-5.238-5.512-5.238-14.748,0-8.831,5.007-14.589t13.9-5.758a17.706,17.706,0,0,1,13.405,5.426q5.18,5.426,5.18,14.488,0,9.38-5.224,15.036a17.512,17.512,0,0,1-13.477,5.657m-.058-8.947a4.571,4.571,0,0,0,4.4-2.67q1.342-2.669,1.342-9.769,0-10.273-5.512-10.274-5.945,0-5.945,11.717,0,11,5.714,11",
    transform: "translate(-732.232 -182.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_441",
    "data-name": "Caminho 441",
    d: "M1168.252,277.192h-13.406l-5.753-15.065h-3.813v15.065h-12.092V237.8h20.577q6.81,0,10.578,3.189a10.484,10.484,0,0,1,3.766,8.413,12.644,12.644,0,0,1-1.386,6.017q-1.385,2.612-5.6,4.6ZM1145.28,253.7h5.166a6.359,6.359,0,0,0,3.665-.952,3.18,3.18,0,0,0,1.385-2.8q0-3.78-4.646-3.781h-5.57Z",
    transform: "translate(-881.175 -184.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    "data-name": "Caminho 442",
    d: "M1352.079,277.192h-13.231l-6.81-14.887-4.086,5.8v9.091h-11.4V237.8h11.4v16.289l10.864-16.289h10.868l-9.949,14.417Z",
    transform: "translate(-1023.761 -184.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    "data-name": "Caminho 443",
    d: "M1570.861,81.646l12.35,24.068h-13.067L1559.522,83.8h-1.644v21.918H1545.95v-82.7h17.366q15.89.042,15.891,17.408V66.387q0,10.96-8.345,15.258m-12.982-46.913V72.415h2.74a11.488,11.488,0,0,0,3.414-.337q3.245-1.306,3.246-5.269V40.381q0-5.648-5.184-5.648Z",
    transform: "translate(-1202.141 -17.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    "data-name": "Caminho 444",
    d: "M1755.093,101.292V30.775l-11.169,2.107V21.544l23.1-4.215v83.963Z",
    transform: "translate(-1356.088 -13.475)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoLogo);
export default __webpack_public_path__ + "static/media/extensivoLogo.41a6824d8c53bf89d5718027d60c871b.svg";
export { ForwardRef as ReactComponent };